import type { FaireProductEntity } from "../../entity_types/product";

export const p_dc5vqdcmvh: FaireProductEntity = {
  token: "p_dc5vqdcmvh",
  type: "product",
  name: "Side By Side Chai - BULK 4lb wholesale",
  brandToken: "b_bzs8cq537a",
  brandName: "Side By Side Chai",
  imageUrl: "https://cdn.faire.com/fastly/b7c324c498ccc6402e60a8bb4defe8d158b3d4ec8ae48d5db07098dcfc7bc75f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd480835db3c2f9b75aa62440f0a185bf919a11a0142648471f80d7de36c059c.jpeg",
    "https://cdn.faire.com/fastly/c510cb1587363528faf0fef6684aaf42217af49e1907dd3c86cfd9714e59cee2.jpeg",
    "https://cdn.faire.com/fastly/9dbe7c1a583e289b57d46d21c3bbdae2ddf3f8dfdb84bf796d4be9dc5433540e.jpeg",
    "https://cdn.faire.com/fastly/dfecf151bcd1acb6b54bc605418bef7536f0d8f0e370be41765c6aa2a56d47c1.jpeg"
  ],
  priceDollars: 51.5,
  description: "This is a bulk order product for serving at your cafe. Not suitable for resale.\n\nYour product will arrive in a sealed white coffee bag with Side by Side branded sticker.\n\n(Servings per 4-lb bag) 75-90 depending on drink size.\n\n(75 - 12oz servings)\n\nWe recommend dosing 2 grams of Chai mix for every ounce of drink.\n\nFor example:\n• 10 oz latte = 20 grams of Chai mix\n• 16 oz latte = 32 grams of Chai mix\n\nPlease note shipping cost will change based on size of order. Shipping will be cheaper (per unit) when ordering multiples.\n\nBest shipping ratio cost is 4 / 4lb (16 lbs) bags in one large flat rate box.\n\n• Non-Dairy\n• Contains caffeine",
  tags: [],
  msrpDollars: 455,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:54.582Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
